// Le corps d'un modèle de communication (CRM-344 ; ADR 20261103_CorpsDesModelesDeCommunication §1) : le document à
// liste fermée du back, et sa traduction vers et depuis le document de l'éditeur (ProseMirror). Fonctions pures, sans
// Tiptap : le back reste seul juge du document (décodage strict), cette traduction ne fait que n'écrire rien d'autre.

const versionDuFormat = 1;

function marquesVersEditeur(marques) {
  return (marques || [])
    .map((m) => (m === "gras" ? { type: "bold" } : m === "italique" ? { type: "italic" } : null))
    .filter(Boolean);
}

function enLigneVersEditeur(noeud) {
  switch (noeud.type) {
    case "texte": {
      const marques = marquesVersEditeur(noeud.marques);
      return noeud.texte === "" ? [] : [{ type: "text", text: noeud.texte, ...(marques.length ? { marks: marques } : {}) }];
    }
    case "lien":
      return [{ type: "text", text: noeud.texte, marks: [{ type: "lien", attrs: { cible: noeud.cible } }] }];
    case "variable":
      return [{ type: "variable", attrs: { nom: noeud.nom } }];
    default:
      return [];
  }
}

function paragrapheVersEditeur(contenu) {
  const enfants = (contenu || []).flatMap(enLigneVersEditeur);
  return enfants.length ? { type: "paragraph", content: enfants } : { type: "paragraph" };
}

function blocVersEditeur(bloc) {
  switch (bloc.type) {
    case "paragraphe":
      return paragrapheVersEditeur(bloc.contenu);
    case "liste":
      return {
        type: bloc.numerotee ? "orderedList" : "bulletList",
        content: bloc.elements.map((e) => ({ type: "listItem", content: [paragrapheVersEditeur(e)] })),
      };
    case "bouton":
      return { type: "bouton", attrs: { libelle: bloc.libelle, cible: bloc.cible } };
    case "image":
      return { type: "image", attrs: { media: bloc.media, alternative: bloc.alternative, largeur: bloc.largeur } };
    default:
      return null;
  }
}

/** Le document du back vers celui de l'éditeur ; un document absent ou vide donne un paragraphe vide. */
export function versEditeur(corps) {
  const blocs = (corps && Array.isArray(corps.blocs) ? corps.blocs : []).map(blocVersEditeur).filter(Boolean);
  return { type: "doc", content: blocs.length ? blocs : [{ type: "paragraph" }] };
}

function enLignesDepuisEditeur(contenu) {
  return (contenu || []).flatMap((n) => {
    if (n.type === "variable") return [{ type: "variable", nom: n.attrs.nom }];
    if (n.type !== "text") return [];
    const marques = n.marks || [];
    const lien = marques.find((m) => m.type === "lien");
    if (lien) return [{ type: "lien", cible: lien.attrs.cible, texte: n.text }];
    const codes = [];
    if (marques.some((m) => m.type === "bold")) codes.push("gras");
    if (marques.some((m) => m.type === "italic")) codes.push("italique");
    return [{ type: "texte", texte: n.text, ...(codes.length ? { marques: codes } : {}) }];
  });
}

function blocDepuisEditeur(noeud) {
  switch (noeud.type) {
    case "paragraph":
      return { type: "paragraphe", contenu: enLignesDepuisEditeur(noeud.content) };
    case "bulletList":
    case "orderedList":
      return {
        type: "liste",
        numerotee: noeud.type === "orderedList",
        elements: (noeud.content || []).map((item) =>
          (item.content || []).flatMap((p) => enLignesDepuisEditeur(p.content)),
        ),
      };
    case "bouton":
      return { type: "bouton", libelle: noeud.attrs.libelle, cible: noeud.attrs.cible };
    case "image":
      return { type: "image", media: noeud.attrs.media, alternative: noeud.attrs.alternative, largeur: noeud.attrs.largeur };
    default:
      return null;
  }
}

/** Le document de l'éditeur vers celui du back : rien que les nœuds et marques de la liste fermée. */
export function depuisEditeur(doc) {
  return { version: versionDuFormat, blocs: ((doc && doc.content) || []).map(blocDepuisEditeur).filter(Boolean) };
}
